// Phase 1A Phase 9C.10c — PhantomSlipHistoryPanel premium-rails sibling.
//
// Token-only sibling overlay. Adds the 9C premium chrome vocabulary
// (cardLow elevation, transitionStandard motion, headerLead +
// rowLead icon-row anchors). The parent style file's row + status
// chrome is preserved by the parent; consumers continue to import
// existing chrome and spread these rails on top.
//
// Trust contract:
//   - No raw hex/rgb. No icons. No emoji.
//   - cardLow + transitionStandard come from the canonical 9C
//     elevation + motion helpers.
//   - No glow, no fake live pulse, no selected-card amber ring.

import type { CSSProperties } from "react";

import { cardLow } from "../../styles/elevation.ts";
import { transitionStandard } from "../../styles/motion.ts";

// ─── Card / row elevation + motion ──────────────────────────────

export const cardRails: CSSProperties = {
  ...cardLow,
  ...transitionStandard,
};

// ─── Header lead row (icon + cardEyebrow) ───────────────────────

export const headerLead: CSSProperties = {
  display: "inline-flex",
  alignItems: "center",
  gap: "var(--sz-space-2)",
  color: "var(--sz-text-secondary)",
};

// ─── Row lead (icon + status pill on a HistoryRow header) ───────

export const rowLead: CSSProperties = {
  display: "inline-flex",
  alignItems: "center",
  gap: "var(--sz-space-2)",
  color: "var(--sz-text-secondary)",
};
